class RelationshipField {
    static relationshipFieldId: number = -1;
    id: number;
    parentFieldId: number;
    childFieldId: number;
    constructor(data: any = null) {
        this.id = data?.id ?? --RelationshipField.relationshipFieldId;
        this.parentFieldId = data?.parentFieldId ?? null;
        this.childFieldId = data?.childFieldId ?? null;
    }
}